import {IMAGES} from "../utils/staticJSON";
import {Offcanvas} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import {Link} from "react-router-dom";
import LOGO from "../assets/media/svg/logo.svg";

interface HeaderProps {
    showButton: boolean;
}

export const HeaderCustom: React.FC<HeaderProps> = ({showButton}) => {
    const [show, setShow] = useState(false);
    const [isScrolled, setIsScrolled] = useState(true);
    const [activeSection, setActiveSection] = useState<string>("home"); // Track active section

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // useEffect(() => {
    //     const handleScroll = () => {
    //         const scrollThreshold = 50;
    //         if (window.scrollY > scrollThreshold) {
    //             setIsScrolled(true);
    //         } else {
    //             setIsScrolled(false);
    //         }
    //     };

    //     window.addEventListener("scroll", handleScroll);

    //     return () => {
    //         window.removeEventListener("scroll", handleScroll);
    //     };
    // }, []);

    // IntersectionObserver to detect active section
    useEffect(() => {
        // const sections = ["home", "features", "about-us", "faqs", "contact-us"];

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {threshold: 0.4} // Trigger when 50% of the section is visible
        );

        // sections.forEach((sectionId) => {
        //     const section = document.getElementById(sectionId);
        //     if (section) {
        //         observer.observe(section);
        //     }
        // });

        // return () => {
        //     sections.forEach((sectionId) => {
        //         const section = document.getElementById(sectionId);
        //         if (section) {
        //             observer.unobserve(section);
        //         }
        //     });
        // };
    }, []);

    return (
        <header className="wrapper">
            <nav
                className={`navbar navbar-expand-lg center-nav navbar-light navbar-bg-light py-0`}
                style={{
                    minHeight: "100px",
                    position: "fixed",
                    backgroundColor: "#007B8B",
                    transition: "background-color 0.3s ease",
                }}
            >
                <div className="container flex-lg-row flex-nowrap align-items-center">
                    <div className="navbar-brand">
                        <NavLink to="/">
                            <img className="" src={LOGO} alt="" />
                        </NavLink>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default HeaderCustom;
